import type { CodeListItem } from "Models/ICodeListDto";
import type { RootStateType } from "State/Store";
import { useMemo } from "react";
import { useSelector } from "react-redux";
import { Resources, useResource } from "Translations/Resources";

type CategoryOption = {
  value: string;
  label: string;
};

export const useFacilityCategoryList = () => {
  const facilityCategories = useSelector(
    (s: RootStateType) => s.codeList.codeLists?.facilityCategories,
  );
  const { t } = useResource();

  const codeListFacilityCategories = useMemo<Array<CodeListItem>>(
    () => facilityCategories?.map(({ code, name }) => ({ code, name })) ?? [],
    [facilityCategories],
  );

  const categoryOptions = useMemo<Array<CategoryOption>>(
    () =>
      codeListFacilityCategories.map((category) => {
        const code =
          category.code as keyof typeof Resources.Common.FacilityCategory;
        const translatedLabel =
          code in Resources.Common.FacilityCategory
            ? t(Resources.Common.FacilityCategory[code])
            : category.name;

        return {
          value: String(category.code),
          label: translatedLabel,
        };
      }),
    [codeListFacilityCategories, t],
  );

  return {
    facilityCategories: facilityCategories ?? [],
    codeListFacilityCategories,
    categoryOptions,
  };
};
